import React from 'react';
import { Link } from 'react-router-dom';

import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholder from 'styles/assets/placeholder/placeholder.gif';
import { trackEventMatomoElementId } from 'js/library/utils/helpers';

export const Store = (data) => {
  const [downloadedImage, setDownloadedImage] = React.useState(null);

  const func = data.func;
  const id = data.data.id;

  data = data.data;
  data.id = id;

  function downloadImageOnLoad() {
    if (data.thumbnail !== undefined && downloadedImage === null) {
      const folder = data.type === 'product' ? 'triibomania-premios' : 'promocao';

      downloadImage(folder, data.thumbnail)
        .then((downloaded) => {
          setDownloadedImage(downloaded);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  const descricao =
    data.description === undefined
      ? ''
      : data.description.length < 50
      ? data.description
      : data.description.substring(0, 50) + '...';

  return (
    <Link
      onClick={() => {
        func();
        trackEventMatomoElementId('Menu', 'tocar', 'lista', data.id);
      }}
      className="search-box"
      to={{ pathname: '/oferta/', search: '?id=' + id, state: data }}
    >
      <div className="search-box__thumb">
        <img
          src={downloadedImage === null ? placeholder : downloadedImage}
          onLoad={() => downloadImageOnLoad()}
          alt="busca"
        />
      </div>
      <div className="search-box__content">
        <span>{data.establishmentName}</span>
        <h3>{data.title}</h3>
        <p>{descricao}</p>
      </div>
    </Link>
  );
};

export default Store;
